import {
  ComponentInfoCardGroup,
  ComponentInfoCard,
} from "types/CMS/KontentAI/content-types";
import { linkResolver } from "./link";
import { infoCard, infoCardGroup } from "types/CMS/Unum/InfoCardGroup";
import { richTextResolver } from "./richText";
import { getUuid } from "utils/util";
import { createResolver } from "./Factories/ResolverFactory";
import { productTaxonomyResolver } from "./products";

export const infoCardGroupResolver = createResolver({
  resolve: (section: ComponentInfoCardGroup): infoCardGroup => {
    const { elements } = section;
    return {
      isFilterable: true,
      productTaxonomy: productTaxonomyResolver.resolve(
        section.elements.products
      ).result,
      key: getUuid(),
      type: "infoCardGroup",
      title: elements.title.value,
      intro: richTextResolver.resolve(elements.intro).result,
      cards: infoCardResolver.resolve(elements.info_cards.linkedItems).result,
      showHeader:
        !!elements.title.value || elements.intro.value !== "<p><br></p>",
    };
  },
});

const infoCardResolver = createResolver({
  resolve: (cards: ComponentInfoCard[]): infoCard[] => {
    return cards.map((card) => {
      const { elements } = card;
      return {
        type: "infoCard",
        title: elements.title.value,
        body: elements.body.value,
        link: linkResolver.resolve(elements.link.linkedItems[0]).result,
      };
    });
  },
});
